import { render, staticRenderFns } from "./approvalProgress.vue?vue&type=template&id=0f5b9ed3&"
import script from "./approvalProgress.vue?vue&type=script&lang=js&"
export * from "./approvalProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports